import React from 'react';
import { Link } from 'react-router-dom';
import { useLocalizedPath } from '../hooks/useLocalizedPath';

/**
 * A wrapper around React Router's Link that automatically adds the current language prefix.
 * Use this instead of Link for all internal navigation to preserve language selection.
 */
const LocalizedLink = ({ to, children, ...props }) => {
  const { getLocalizedPath } = useLocalizedPath();

  return (
    <Link to={getLocalizedPath(to)} {...props}>
      {children}
    </Link>
  );
};

export default LocalizedLink;
